import React, { useState, useEffect } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import NoDataFound from "../../../partials/NoDataFound"
import { trans } from "../../../../_providers/Translation"
import SubscriptionOptions from "../list/SubscriptionOptions"
import moment from "moment"
import alertImage from "@/assets/img/contractors/icons/alert.svg"
import { Tooltip } from "@mui/material"
import Pagination from "@/components/Pagination"

export default function SubscriptionsList({
  handleEdit,
  handleDelete,
  handleActivate,
  handleRenew,
  handleDeactivate,
  refresh,
}) {
  const [data, setData] = useState({
    loading: true,
    data: [],
    page: 1,
    pages: 0,
    update: false,
  })

  useEffect(() => {
    loadSubscriptions()
  }, [refresh, data.update])

  const loadSubscriptions = () => {
    setData((prev) => ({
      ...prev,
      loading: true,
    }))

    let url = "subscriptions?page=" + data.page

    Api.get(url)
      .then((res) => {
        setData((prev) => ({
          ...prev,
          loading: false,
          data: res.data.items,
          pages: res.data.pages,
        }))
      })
      .catch(() => {
        setData((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const handlePage = (page) => {
    setData((prev) => ({
      ...prev,
      page: page.selected + 1,
      update: new Date().getTime(),
    }))
  }

  return (
    <div className="pannel">
      {data.loading ? (
        <Skeleton height={45} count={10} />
      ) : data.data.length === 0 ? (
        <NoDataFound message={trans("messages.noAddedSubscriptions")} />
      ) : (
        <>
          <div className="table-scroller">
          <table>
            <thead>
              <tr>
                <th>{trans("tables.refNo")}</th>
                <th>{trans("tables.name")}</th>
                <th>{trans("tables.status")}</th>
                <th>{trans("tables.type")}</th>
                <th>{trans("tables.devicesCountFull")}</th>
                <th>{trans("tables.activatedAt")}</th>
                <th>{trans("tables.expiresOn")}</th>
                <th className="options">{trans("tables.options")}</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((sub) => {
                const daysUntilDue = moment(
                  sub.expires_at_dmy,
                  "DD.MM.YYYY",
                ).diff(moment(), "days")
                const isOverdue = daysUntilDue <= 0
                const isNear = daysUntilDue > 0 && daysUntilDue <= 20

                return (
                  <tr key={"sub-" + sub.id}>
                    <td>{sub.ref || "-"}</td>
                    <td>{sub.name || "-"}</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <span
                          style={{
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            backgroundColor: sub.is_active
                              ? "#4BB543"
                              : "#EC5252",
                          }}
                        ></span>
                        {sub.is_active ? trans('random.activeStatus') : trans('random.inactiveStatus')}
                      </div>
                    </td>
                    <td>{sub?.type?.name || "-"}</td>
                    <td>{sub?.appliances_count || "-"}</td>
                    <td>
                      {sub.activated_at_dmy
                        ? moment(sub.activated_at_dmy, "DD.MM.YYYY").format(
                            "DD MMM YYYY",
                          )
                        : "-"}
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        {!sub.expires_at_dmy ? (
                          trans('random.indefinite')
                        ) : (
                          <>
                            {isOverdue && (
                              <Tooltip title={trans('messages.subscriptionHasExpired')}>
                                <img src={alertImage} alt="" />
                              </Tooltip>
                            )}
                            {moment(
                              sub.expires_at_dmy,
                              "DD.MM.YYYY",
                            ).format("DD MMM YYYY")}
                            {!isOverdue && (
                              <span
                                style={isNear ? { color: "#EC5252" } : {}}
                              >{`(${daysUntilDue} дни)`}</span>
                            )}
                          </>
                        )}
                      </div>
                    </td>
                    <td>
                      <SubscriptionOptions
                        id={sub.id}
                        data={sub}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handleActivate={handleActivate}
                        handleRenew={handleRenew}
                        handleDeactivate={handleDeactivate}
                      />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <Pagination
          pages={data.pages}
          page={data.page}
          handlePage={handlePage}
        />
      </>
      )}
    </div>
  )
}
